
export default {

    createPDF(date_protocol,
              chairman,
              secretary,
              faculty,
              listeners,
              signatures,
              candidates,) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        };
        let docInfo = {
            info: {
                title: `Протокол заседания повышенной ГАС.`,
                author: 'ФБГОУ ВО АмГУ',
                subject: '',
                keywords: ''
            },

            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [30, 20, 20, 20],


            content: [
                {
                    text: 'Федеральное государственное бюджетное образовательное учреждение высшего образования',
                    style: "thirteenBold", alignment: 'center',
                },

                {
                    text: '«Амурский государственный университет»',
                    style: "thirteenBold", alignment: 'center',
                },

                {
                    text: '(ФГБОУ ВО «АмГУ»)',
                    margin: [0, 0, 0, 15],
                    style: "thirteenBold", alignment: 'center',
                },

                {
                    text: 'ПРОТОКОЛ',
                    style: "thirteenBold", alignment: 'center'
                },
                {
                    text: 'заседания стипендиальной комиссии',
                    style: "thirteenBold", alignment: 'center'
                },

                {
                    text: faculty,
                    decoration: 'underline',
                    style: "thirteenBold", alignment: 'center',
                },

                {
                    text: 'наименование факультета',
                    margin: [0, 0, 0, 50],
                    style: "thirteenBold", alignment: 'center', fontSize: 8
                },

                {
                    alignment: 'justify',
                    columnGap: 10,
                    columns: [
                        {
                            width: '60%',
                            text: date_protocol + " г.",
                            margin: [30, 0, 0, 15],
                            style: "thirteenBold",
                        },
                        {
                            columns: [
                                {
                                    text: "№",
                                    style: "thirteenBold",
                                },
                                {
                                    text: "                            ",
                                    decoration: 'underline',
                                    style: "thirteenBold",
                                }
                            ],
                        }
                    ]
                },

                {
                    columns: [
                        {
                            text: "\t\tПредседатель: – ",
                            style: "thirteenBold",
                            width: "25%",
                            preserveLeadingSpaces: true,
                        },
                        {
                            text: chairman,
                            decoration: 'underline',
                            style: "thirteenBold",
                            width: "*",
                        }
                    ],
                },

                {
                    text: 'Фамилия И.О.',
                    style: "thirteenBold",
                    fontSize: 8,
                    alignment: 'left',
                    margin: [150, 0, 0, 15],
                },

                {
                    columns: [
                        {
                            text: "\t\tСекретарь: – ",
                            style: "thirteenBold",
                            width: "21%",
                            preserveLeadingSpaces: true,
                        },
                        {
                            text: secretary,
                            decoration: 'underline',
                            style: "thirteenBold",
                            width: "*",
                        }
                    ],
                },

                {
                    text: 'Фамилия И.О.',
                    style: "thirteenBold",
                    fontSize: 8,
                    alignment: 'left',
                    margin: [130, 0, 0, 20],
                },

                {
                    text: "\t\tПрисутствовали: " + listeners,
                    style: "thirteenBold",
                    width: "17%",
                    preserveLeadingSpaces: true,
                },

                {
                    text: 'ПОВЕСТКА ДНЯ',
                    style: "thirteenBold",
                    margin:[0, 20],
                    alignment: 'center',
                },

                {
                    text: "\t\tОпределение победителей конкурса на получение повышенной стипендии на основании совокупного анализа представленных студентами документов",
                    style: "thirteenBold",
                    preserveLeadingSpaces: true,
                },
                {
                    text: "Слушали: " + listeners,
                    style: "thirteenBold",
                    margin:[0, 20],
                },
                {
                    text: "\t\tПостановили: Утвердить следующий список студентов, претендующих на повышенную государственную академическую стипендию:",
                    style: "thirteenBold",
                    preserveLeadingSpaces: true,
                },
                {
                    style: 'thirteenBold',
                    fontSize: 10,
                    margin: [0, 15, 0, 20],
                    table: {
                        body: [
                            [
                                {text: "№", rowSpan: 2, alignment: 'center'},
                                {text: 'Ф.И.О Студента', rowSpan: 2, wrap: true, alignment: 'center'},
                                {text: 'Курс, Группа', rowSpan: 2, alignment: 'center'},
                                {text: 'Приоритетный тип деятельности', rowSpan: 2, alignment: 'center'},
                                {text: 'Суммарные баллы по каждому виду деятельности', colSpan: 5, alignment: 'center',},
                                {},
                                {},
                                {},
                                {},
                                {text: 'Итоговый балл по всем видам дея-тельности', alignment: 'center', rowSpan: 2},
                            ],
                            [
                                {},
                                {},
                                {},
                                {},
                                {text: "учеб-ная", alignment: 'center'},
                                {text: 'научно-исследова-тельская', alignment: 'center'},
                                {text: 'обще-ствен-ная', alignment: 'center'},
                                {text: 'культурно-творческая', alignment: 'center'},
                                {text: 'спор-тив-ная', alignment: 'center'},
                                {},
                            ],
                            ...candidates
                            // 	['One value goes here', 'Another one here', 'OK?']
                        ]
                    }
                },

                    {
                        margin: [0, 0, 0, 20],
                        columns: [
                            {
                                text: "Председатель стипендиальной комиссии",
                                style: "thirteenBold",
                                width: 300,
                            },

                            {
                                width: '*',
                                canvas:
                                    [{ type: 'line', x1: 0, y1: 15, x2: 100, y2: 15, lineWidth: 1 }]
                            },

                            {
                                text: chairman,
                                style: "thirteenBold",
                                width: "auto",
                            }
                        ],
                    },

                    {
                        margin: [0, 0, 0, 20],
                        columns: [
                            {
                                text: "Секретарь стипендиальной комиссии",
                                style: "thirteenBold",
                                width: 300,
                            },

                            {
                                width: '*',
                                canvas:
                                    [{ type: 'line', x1: 0, y1: 15, x2: 100, y2: 15, lineWidth: 1 }]
                            },

                            {
                                text: secretary,
                                style: "thirteenBold",
                                width: "auto",
                            }
                        ],
                    },

                ...signatures

            ],
            styles: {
                thirteenBold: {
                    fontSize: 14,
                    font: 'Times',
                }
            }


        }
        pdfMake.createPdf(docInfo).download('Протокол заседания повышенной ГАС.pdf')
    }
}